import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | أكاديمية خرابيش` : "أكاديمية خرابيش | كورسات موشن جرافيك وأنيميشن";
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}
